"use strict" ;

/**
 * This constant equal <code>Math.PI*2</code>.
 * @name PI2
 * @memberof core.maths
 * @instance
 * @const
 * @default Math.PI * 2
 */
const PI2 = Math.PI * 2 ;

export default PI2;
